import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { EditorNotificationsErrorsWithWithContainer } from '../editor/EditorNotifications';
import { observer } from 'mobx-react-lite';
import { authLogin } from '../../communication/api';
import { ErrorType } from '../../stores/editor/ErrorNotification';
import { CenterContainer, Overlay, PopupWindow } from '../shared/PopupComponents';
import { userStore } from '../../stores/UserStore';
import { errorStore } from '../../stores/ErrorStore';
import { useHistory } from 'react-router';
import { navigateTo } from '../../helper/navigationHelpers';
import { routes } from '../../data/routes';
import { Heading1Base } from '../shared/Heading';
import { AdamaraLogo } from '../shared/AdamaraLogo';
import { tryToTranslateAxiosError } from '../../helper/errorHelpers';
import { Link } from 'react-router-dom';
import { FloatingLanguageSwitcher } from '../editor/FloatingLanguageSwitcher';
const Form = styled.form.withConfig({
  displayName: "LoginForm__Form",
  componentId: "sc-1p84t7q-0"
})(["text-align:center;*{margin-top:0.4em;}"]);
const Center = styled.div.withConfig({
  displayName: "LoginForm__Center",
  componentId: "sc-1p84t7q-1"
})(["text-align:center;"]);
export const LoginForm = observer(() => {
  const {
    t
  } = useTranslation();
  const [accessCode, setAccessCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();

  async function onSubmit(e) {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const authPrivilege = (await authLogin("-", accessCode)).user.privilegeLevel;
      userStore.setLoggedIn(authPrivilege);

      if (userStore.isWorkshopPlayer) {
        navigateTo(history, routes.playCode);
      } else if (userStore.isWorkshopParticipant) {
        navigateTo(history, routes.editorAction);
      }
    } catch (e) {
      var _e$response;

      if (((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
        errorStore.addError(ErrorType.General, "editor.auth_login_fail");
      } else {
        errorStore.addErrorFromErrorObject(tryToTranslateAxiosError(e));
      }

      setAccessCode("");
      setIsSubmitting(false);
    }
  }

  return /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(PopupWindow, null, /*#__PURE__*/React.createElement(AdamaraLogo, null), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Heading1Base, null, t("editor.auth_login_title")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    disabled: isSubmitting,
    type: "password",
    value: accessCode,
    onChange: e => setAccessCode(e.target.value),
    autoFocus: true
  })), /*#__PURE__*/React.createElement("input", {
    disabled: isSubmitting || !accessCode,
    type: "submit",
    value: t("editor.auth_submit")
  }), errorStore.hasErrors && /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(EditorNotificationsErrorsWithWithContainer, null))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Link, {
    to: routes.publicMenu
  }, t("editor.play_game"))))), /*#__PURE__*/React.createElement(FloatingLanguageSwitcher, null));
});